import React from "react";
import { t } from "ttag";

import { LocationProximity } from "../../models";
import { Clickable } from "../Clickables";
import { Svg } from "../Svg";
import { Address } from "./Address";
import { Distance } from "./Distance";
import { IndexGlyph } from "./IndexGlyph";
import { PhoneNumber } from "./PhoneNumber";
import { TodaysHours } from "./TodaysHours";

import styles from "./LocationListItem.module.scss";

export type LocationListItemProps = LocationProximity & {
    index: number;
    onSelect: () => void;
};

export const LocationListItem = (props: LocationListItemProps) => {
    return (
        <li className={styles.li} data-id={props.location.id}>
            <Clickable onPress={props.onSelect} className={styles.clickable}>
                <IndexGlyph index={props.index} />
                <h3 className={styles.locationName}>
                    {props.location.display_name}
                </h3>
            </Clickable>
            <Distance distance={props.distance} />
            <Address location={props.location} />
            {props.location.website_url && (
                <Clickable
                    href={props.location.website_url}
                    target="_blank"
                    rel="noreferrer"
                    className={styles.itemWithIcon}
                >
                    <Svg
                        name="external"
                        aria-hidden="true"
                        className={styles.svg}
                    />
                    <span className={styles.textLink}>
                        {props.location.website_url}
                    </span>
                </Clickable>
            )}
            {props.location.phone && (
                <PhoneNumber phone={props.location.phone} />
            )}
            <TodaysHours />

            {!props.location.appliances_available && (
                <div className={styles.appliancesAvailable}>
                    <Svg
                        name="check"
                        visuallyHiddenText={null}
                        aria-hidden="true"
                        className={styles.checkSvg}
                    />
                    {t`Display coming soon`}
                </div>
            )}
        </li>
    );
};
